import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { supabase } from "../../../lib/supabaseClient";
import { Link } from "react-router-dom";

// Import icons
import retailIcon from './SVG/1_CHARIOT.png';
import shoppingIcon from './SVG/2_SHOPPING.png';
import hotelIcon from './SVG/3_SONETTE.png';
import officeIcon from './SVG/8_OFFICE_STROKE.png';
import restaurantIcon from './SVG/5_CUISINE.png';
import culturalIcon from './SVG/6_PEINTURE.png';
import residenceIcon from './SVG/7_SERRURE.png';
import urbanIcon from './SVG/8_BANC.png';
import installationIcon from './SVG/9_INSTALLATION_SCENOGRAPHY.png';
import clusterIcon from './SVG/logo16.png';
import city from './SVG/city3.png';
import city_card from './SVG/city_horizontal.png';
import * as api from '../../../api';
import monthlyarchiIcon from './MonthlyIcons/architecture.png';
import monthlyculturalIcon from './MonthlyIcons/culture.png';
import monthlyhotelIcon from './MonthlyIcons/hotel.png';
import monthlyretailIcon from './MonthlyIcons/retail.png';
import monthlyresidenceIcon from './MonthlyIcons/private.png';
import monthlyofficeIcon from './MonthlyIcons/office.png';
import monthlyurbanIcon from './MonthlyIcons/urban.png';
import monthlyrestaurantIcon from './MonthlyIcons/restaurant.png';

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

// Helper function to format category names for display
const formatCategoryForDisplay = (category) => {
    if (category === "Installation/Scenography") {
        return "Installation / Scenography";
    }
    return category;
};

const POINT_ICONS = {
    "Retail": shoppingIcon,
    "Hotel": hotelIcon,
    "Office": officeIcon,
    "Restaurant/bar": restaurantIcon,
    "Cultural space": culturalIcon,
    "Private residence": residenceIcon,
    "Urban space/Transportation": urbanIcon,
    "Installation/Scenography": installationIcon
};

const MONTHLY_ICONS = {
    "Retail": monthlyretailIcon,
    "Hotel": monthlyhotelIcon,
    "Office": monthlyofficeIcon,
    "Restaurant/bar": monthlyrestaurantIcon,
    "Cultural space": monthlyculturalIcon,
    "Private residence": monthlyresidenceIcon,
    "Urban space/Transportation": monthlyurbanIcon,
    "Architecture": monthlyarchiIcon,
    "Installation/Scenography": installationIcon // Using regular icon as fallback
};

const SearchBar = ({ onSearch }) => {
    return (
        <div style={{
            padding: '20px',
            backgroundColor: 'white',
            borderBottom: '1px solid #eee',
            position: 'relative',
            zIndex: 2,
            width: '100%',
            display: 'flex'
        }}>
            <Link to='/annuaire'>
                <img style={{width:'150px'}} src='/img/LogosV3.png' alt='Le FRENCH DESIGN'/>
            </Link>
            <input
                type="text"
                placeholder="Search projects..."
                onChange={(e) => onSearch(e.target.value)}
                style={{
                    width: '100%',
                    maxWidth: '600px',
                    padding: '12px 20px',
                    fontSize: '16px',
                    border: '1px solid black',
                    borderRadius: '4px',
                    margin: '0 auto',
                    display: 'block',
                    height: '50px',
                    alignSelf: 'center'
                }}
            />
        </div>
    );
};

const DesignMapFramed = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [MonthlyProject, setProject] = useState(null);
    const mapContainer = useRef(null);
    const map = useRef(null);
    const sourceLoaded = useRef(false);

    // Load a single icon
    const loadIcon = async (mapInstance, iconKey, iconPath) => {
        return new Promise((resolve, reject) => {
            if (!mapInstance.hasImage(iconKey)) {
                const image = new Image();
                image.src = iconPath;
                image.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = image.width;
                    canvas.height = image.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(image, 0, 0);
                    mapInstance.addImage(iconKey, ctx.getImageData(0, 0, canvas.width, canvas.height));
                    resolve();
                };
                image.onerror = reject;
            } else {
                resolve();
            }
        });
    };

    // Load all icons
    const loadAllIcons = async (mapInstance) => {
        try {
            // Load regular icons
            await Promise.all(
                Object.entries(POINT_ICONS).map(([key, path]) => 
                    loadIcon(mapInstance, key, path)
                )
            );

            // Load monthly icons
            await Promise.all(
                Object.entries(MONTHLY_ICONS).map(([key, path]) => 
                    loadIcon(mapInstance, `monthly-${key}`, path)
                )
            );

            // Load special icons
            await Promise.all([
                loadIcon(mapInstance, 'cluster-icon', clusterIcon),
                loadIcon(mapInstance, 'city-icon', city),
                loadIcon(mapInstance, 'points-of-sale-icon', retailIcon)
            ]);

        } catch (error) {
            console.error("Error loading icons:", error);
        }
    };

    const setupPopupsAndHandlers = () => {
        if (!map.current) return;

        const popup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false,
            offset: 15,
            maxWidth: '300px'
        });

        // Add hover effects for points
        map.current.on('mouseenter', 'vectorLayer', (e) => {
            map.current.getCanvas().style.cursor = 'pointer';
            const coordinates = e.features[0].geometry.coordinates.slice();
            const properties = e.features[0].properties;

            // Create popup content based on project type
            const popupContent = properties.projectType === 'itc' 
                ? `
                    <div class="mappopup" style="width: 200px; padding:0; border:1px solid; margin:none;">
                        <img src="${city_card}" alt="In The City" style="width: 80%; height: auto;display:block; margin-bottom: 8px;margin:auto">
                        <div class="infocontainer">
                            <div style="margin-bottom: 4px; color:blue; font-weight: bold;">
                                ${properties.nom_etablissement}
                            </div>
                            <div style="font-size: 12px; text-transform:none; line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;">
                                ${properties.description_projet || ''}
                            </div>
                        </div>
                    </div>
                `
                : properties.projectType === 'pos' 
                ? `
                    <div class="mappopup" style="width: 200px;padding:0; border:1px solid;margin:none;">
                        <img style="max-width:80%; margin:auto;display:block" src="${properties.photos_projet ? properties.photos_projet.split(',')[0].trim() : retailIcon}" alt="Project">
                        <div class="infocontainer">
                            <div style="font-weight: bold; margin-bottom: 4px;color: red">Point of sale</div>
                            <div style="margin-bottom: 4px;color:blue;font-weight: bold;">${properties.design_points_of_sales}</div>
                            <div style="font-weight: bold;">${properties.titre_affiche}</div>
                        </div>
                    </div>
                `
                : properties.isMonthly
                ? `
                    <div class="mappopup" style="width: 200px;padding:0; border:1px solid;margin:none;">
                                                <div style="font-weight: bold;text-align:center">Projet du moment</div>

                        <img src="${properties.photos_projet?.split(',')[0].trim()}" alt="Project" style="width: 100%; height: 150px; object-fit: cover; margin-bottom: 8px;">
                        <div class="infocontainer">
                            <div style="font-weight: bold; margin-bottom: 4px;color: red">${formatCategoryForDisplay(properties.points_of_interest)}</div>
                            <div style="font-weight: bold;color:blue; margin-bottom: 4px;">${properties.nom_etablissement}</div>
                            <div style="font-weight: bold;">${properties.titre_affiche}</div>

                        </div>
                    </div>
                `
                : `
                    <div class="mappopup" style="width: 200px;padding:0; border:1px solid;margin:none;">
                        <img src="${properties.photos_projet?.split(',')[0].trim()}" alt="Project" style="width: 100%; height: 150px; object-fit: cover; margin-bottom: 8px;">
                        <div class="infocontainer">
                            <div style="font-weight: bold; margin-bottom: 4px;color: red">${formatCategoryForDisplay(properties.points_of_interest)}</div>
                            <div style="margin-bottom: 4px;color:blue;font-weight: bold;">${properties.fiche_agence}</div>
                            <div style="font-weight: bold;">${properties.titre_affiche}</div>
                        </div>
                    </div>
                `;

            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }

            popup
                .setLngLat(coordinates)
                .setHTML(popupContent)
                .addTo(map.current);
        });

        map.current.on('mouseleave', 'vectorLayer', () => {
            map.current.getCanvas().style.cursor = '';
            popup.remove();
        });

        // Add cluster click handler
        map.current.on('click', 'clusters', (e) => {
            const features = map.current.queryRenderedFeatures(e.point, {
                layers: ['clusters']
            });
            const clusterId = features[0].properties.cluster_id;
            map.current.getSource('vectorSource').getClusterExpansionZoom(
                clusterId,
                (error, zoom) => {
                    if (error) return;
                    
                    map.current.easeTo({
                        center: features[0].geometry.coordinates,
                        zoom: zoom + 1
                    });
                }
            );
        });
    };

    // Combined data fetching function
    const initializeMapData = async (mapInstance) => {
        try {
            // Fetch monthly project first
            const monthlyResponse = await api.GetMonthlyMapProject();
            const monthlyProject = monthlyResponse.data;
            setProject(monthlyProject);
            
            // Fetch all other data
            const [projectsResponse, itcResponse, posResponse] = await Promise.all([
                supabase.from('projects').select('*'),
                supabase.from('itc_2025').select('*'),
                supabase.from('points_of_sale').select('*')
            ]);

            // Process regular projects with monthly status
            const regularFeatures = projectsResponse.data.map(project => ({
                type: "Feature",
                properties: {
                    ...project,
                    projectType: 'regular',
                    isMonthly: project.mongo_project_id === monthlyProject?.mongo_project_id
                },
                geometry: {
                    type: "Point",
                    coordinates: [project.longitude, project.latitude]
                }
            }));

            // Process ITC projects
            const itcFeatures = itcResponse.data.map(project => ({
                type: "Feature",
                properties: {
                    ...project,
                    projectType: 'itc'
                },
                geometry: {
                    type: "Point",
                    coordinates: [project.longitude, project.latitude]
                }
            }));

            // Process points of sale
            const posFeatures = posResponse.data.map(pos => ({
                type: "Feature",
                properties: {
                    ...pos,
                    projectType: 'pos'
                },
                geometry: {
                    type: "Point",
                    coordinates: [pos.longitude, pos.latitude]
                }
            }));

            // Combine all features
            const geoJsonData = {
                type: "FeatureCollection",
                features: [...regularFeatures, ...itcFeatures, ...posFeatures]
            };

            // Add or update source
            if (!mapInstance.getSource('vectorSource')) {
                mapInstance.addSource('vectorSource', {
                    type: 'geojson',
                    data: geoJsonData,
                    cluster: true,
                    clusterMaxZoom: 14,
                    clusterRadius: 50
                });

                // Add clusters layer
                mapInstance.addLayer({
                    id: 'clusters',
                    type: 'symbol',
                    source: 'vectorSource',
                    filter: ['has', 'point_count'],
                    layout: {
                        'icon-image': 'cluster-icon',
                        'icon-size': 0.5,
                        'icon-allow-overlap': true,
                        'text-field': '{point_count_abbreviated}',
                        'text-font': ['DIN Offc Pro Bold', 'Arial Unicode MS Bold'],
                        'text-size': 20,
                        'text-offset': [1.5, -1.5],
                        'text-anchor': 'top-right'
                    },
                    paint: {
                        'text-color': 'black',
                        'text-halo-color': 'white',
                        'text-halo-width': 2,
                        'text-halo-blur': 1
                    }
                });

                // Add vector layer
                mapInstance.addLayer({
                    id: 'vectorLayer',
                    type: 'symbol',
                    source: 'vectorSource',
                    filter: ['!', ['has', 'point_count']],
                    layout: {
                        'icon-image': [
                            'case',
                            ['==', ['get', 'isMonthly'], true],
                            [
                                'match',
                                ['get', 'points_of_interest'],
                                'Retail', 'monthly-Retail',
                                'Hotel', 'monthly-Hotel',
                                'Office', 'monthly-Office',
                                'Restaurant/bar', 'monthly-Restaurant/bar',
                                'Cultural space', 'monthly-Cultural space',
                                'Private residence', 'monthly-Private residence',
                                'Urban space/Transportation', 'monthly-Urban space/Transportation',
                                'Architecture', 'monthly-Architecture',
                                'Installation/Scenography', 'monthly-Installation/Scenography',
                                'default-icon'
                            ],
                            ['==', ['get', 'projectType'], 'itc'],
                            'city-icon',
                            ['==', ['get', 'projectType'], 'pos'],
                            'points-of-sale-icon',
                            [
                                'match',
                                ['get', 'points_of_interest'],
                                'Retail', 'Retail',
                                'Hotel', 'Hotel',
                                'Office', 'Office',
                                'Restaurant/bar', 'Restaurant/bar',
                                'Cultural space', 'Cultural space',
                                'Private residence', 'Private residence',
                                'Urban space/Transportation', 'Urban space/Transportation',
                                'Installation/Scenography', 'Installation/Scenography',
                                'default-icon'
                            ]
                        ],
                        'icon-size': [
                            'case',
                            ['==', ['get', 'isMonthly'], true],
                            0.6,
                            0.4
                        ],
                        'icon-allow-overlap': true
                    }
                });

                sourceLoaded.current = true;
            } else {
                mapInstance.getSource('vectorSource').setData(geoJsonData);
            }

            // Zoom to monthly project if available
            if (monthlyProject?.longitude && monthlyProject?.latitude) {
                mapInstance.flyTo({
                    center: [monthlyProject.longitude, monthlyProject.latitude],
                    zoom: 15,
                    duration: 2000
                });
            }

        } catch (error) {
            console.error('Error initializing map data:', error);
        }
    };

    // Initial setup effect
    useEffect(() => {
        if (!map.current && mapContainer.current) {
            mapboxgl.accessToken = 'pk.eyJ1IjoiZGdjb2Jvc3MiLCJhIjoiY2xzY2JnajIzMGZsNzJpcGM4b3l5OWttaCJ9.1GzkF8EERgQ5u1jkmP3C7w';
            map.current = new mapboxgl.Map({
                container: mapContainer.current,
                style: 'mapbox://styles/dgcoboss/cm5k9ztpe003g01s76e7v8owz',
                center: [2.349014, 0],
                zoom: 2,
                projection: 'mercator'
            });
    
            map.current.on('load', async () => {
                // Create the logo container to hold both the logo and tooltip
                const logoContainer = document.createElement('div');
                logoContainer.id = 'logo-container';
                logoContainer.style.position = 'absolute';
                logoContainer.style.top = '10px';
                logoContainer.style.left = '10px';
                logoContainer.style.width = '100px';

                logoContainer.style.zIndex = '10'; // Increased z-index to ensure visibility
                logoContainer.style.cursor = 'pointer';
                logoContainer.style.transition = 'transform 0.3s ease';
                
                // Create the logo image with a more reliable path
                const logo = document.createElement('img');
                logo.src = 'logomap.svg'; // Updated path to match your project structure
                logo.alt = 'Map Logo';
                logo.id = 'logo-overlay';
                logo.style.width = '100px';
                logo.style.height = '100px';
                
                // Add error handling for the logo image
                logo.onerror = function() {
                    console.error('Failed to load logo from primary path, trying alternative...');
                    // Try alternative paths if the first one fails
                    const alternativePaths = [
                        'logomap.svg',
                        '/logomap.svg',
                        './SVG/logomap.svg',
                        './logomap.svg',
                        '../logomap.svg',
                        '../../logomap.svg',
                        '/images/logomap.svg'
                    ];
                    
                    let pathIndex = 0;
                    const tryNextPath = () => {
                        if (pathIndex < alternativePaths.length) {
                            logo.src = alternativePaths[pathIndex];
                            pathIndex++;
                        } else {
                            // If all paths fail, use a fallback text element
                            const fallbackText = document.createElement('div');
                            fallbackText.innerText = 'FULL MAP';
                            fallbackText.style.width = '100px';
                            fallbackText.style.height = '100px';
                            fallbackText.style.backgroundColor = 'black';
                            fallbackText.style.color = 'white';
                            fallbackText.style.display = 'flex';
                            fallbackText.style.alignItems = 'center';
                            fallbackText.style.justifyContent = 'center';
                            fallbackText.style.borderRadius = '50%';
                            fallbackText.style.fontWeight = 'bold';
                            fallbackText.style.textAlign = 'center';
                            
                            // Replace the img with the text element
                            logoContainer.replaceChild(fallbackText, logo);
                            console.log('Using fallback text for logo');
                        }
                    };
                    
                    // Start trying alternative paths
                    tryNextPath();
                };
                
                // Create tooltip element
                const tooltip = document.createElement('div');
                tooltip.id = 'logo-tooltip';
                tooltip.innerText = 'Cliquez pour accéder à la Worldmap';
                tooltip.style.position = 'absolute';
                tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
                tooltip.style.color = 'white';
                tooltip.style.padding = '8px 12px';
                tooltip.style.borderRadius = '4px';
                tooltip.style.fontSize = '14px';
                tooltip.style.marginTop = '14px';

                tooltip.style.whiteSpace = 'nowrap';
                tooltip.style.top = '110px';
                tooltip.style.left = '0';
                tooltip.style.opacity = '0';
                tooltip.style.transition = 'opacity 0.3s ease';
                tooltip.style.pointerEvents = 'none'; // Prevents the tooltip from blocking clicks
                tooltip.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
                tooltip.style.zIndex = '11'; // Make sure tooltip is above logo
                
                // Add hover animations
                logoContainer.addEventListener('mouseenter', () => {
                    // Pulse animation
                    logoContainer.style.transform = 'scale(1.1)';
                    tooltip.style.opacity = '1';
                    
                    // Add a subtle glow effect to the logo
                    logo.style.filter = 'drop-shadow(0 0 8px rgba(255, 255, 255, 0.8))';
                });
                
                logoContainer.addEventListener('mouseleave', () => {
                    logoContainer.style.transform = 'scale(1)';
                    tooltip.style.opacity = '0';
                    logo.style.filter = 'none';
                });
                
                // Add click handler
                logoContainer.addEventListener('click', () => {
                    // Check if we're in an iframe
                    if (window.self !== window.top) {
                        // Send message to parent window
                        window.parent.postMessage({
                            type: 'NAVIGATE',
                            path: '/worldmap'  // Replace with your desired navigation path
                        }, '*');
                    } else {
                        // Fallback for when not in iframe
                        window.location.href = '/worldmap';
                    }
                });
                
                // Append elements to container
                logoContainer.appendChild(logo);
                logoContainer.appendChild(tooltip);
                
                // Add the container to the map
                mapContainer.current.appendChild(logoContainer);
                
                // Log that the logo container was added
                console.log('Logo container added to map container:', logoContainer);
                
                // Create initial attention-grabbing animation when map loads
                setTimeout(() => {
                    logoContainer.style.transform = 'scale(1.1)';
                    tooltip.style.opacity = '1';
                    logo.style.filter = 'drop-shadow(0 0 8px rgba(255, 255, 255, 0.8))';
                    
                    setTimeout(() => {
                        logoContainer.style.transform = 'scale(1)';
                        tooltip.style.opacity = '0';
                        logo.style.filter = 'none';
                    }, 2000);
                }, 1000);
                
                await loadAllIcons(map.current);
                await initializeMapData(map.current);
                setupPopupsAndHandlers();
            });
        }
    
        return () => {
            if (map.current) {
                map.current.remove();
            }
        };
    }, []);
    
    useEffect(() => {
        // Show the popup for the Monthly Project when it changes
        if (map.current && MonthlyProject?.longitude && MonthlyProject?.latitude) {
            const popupContent = `
               <div class="mappopup" style="width: 200px;padding:0; border:1px solid;margin:none;">
                                                <div style="font-weight: bold;text-align:center">Projet du moment</div>

                        <img src="${MonthlyProject.photos_projet?.split(',')[0].trim()}" alt="Project" style="width: 100%; height: 150px; object-fit: cover; margin-bottom: 8px;">
                        <div class="infocontainer">
                            <div style="font-weight: bold; margin-bottom: 4px;color: red">${MonthlyProject.points_of_interest}</div>
                            <div style="font-weight: bold;color:blue; margin-bottom: 4px;">${MonthlyProject.nom_etablissement}</div>
                            <div style="font-weight: bold;">${MonthlyProject.titre_affiche}</div>

                        </div>
                    </div>
            `;
    
            new mapboxgl.Popup({ offset: 35, closeButton: false, maxWidth: '300px' })
                .setLngLat([MonthlyProject.longitude, MonthlyProject.latitude])
                .setHTML(popupContent)
                .addTo(map.current);
    
            // Optionally fly to the Monthly Project location
            map.current.flyTo({
                center: [MonthlyProject.longitude, MonthlyProject.latitude],
                zoom: 15,
                duration: 2000
            });
        }
    }, [MonthlyProject]);

    // Update effect for MonthlyProject changes
    useEffect(() => {
        if (map.current && sourceLoaded.current && MonthlyProject) {
            const source = map.current.getSource('vectorSource');
            if (source) {
                const currentData = source._data;
                const updatedFeatures = currentData.features.map(feature => ({
                    ...feature,
                    properties: {
                        ...feature.properties,
                        isMonthly: feature.properties.mongo_project_id === MonthlyProject.mongo_project_id
                    }
                }));

                source.setData({
                    type: 'FeatureCollection',
                    features: updatedFeatures
                });

                // Ensure monthly icon is loaded
                if (MonthlyProject.points_of_interest) {
                    const monthlyIconKey = `monthly-${MonthlyProject.points_of_interest}`;
                    if (!map.current.hasImage(monthlyIconKey)) {
                        loadIcon(map.current, monthlyIconKey, MONTHLY_ICONS[MonthlyProject.points_of_interest]);
                    }
                }
            }
        }
    }, [MonthlyProject]);

    return (
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
            {/* <SearchBar onSearch={handleSearch} /> */}
            <div className="design-map-container" style={{ position: 'relative', width: '100%', height: '100vh', borderTop:'solid 1px', borderBottom:'solid 1px' }}>
                <div 
                    ref={mapContainer} 
                    id="map" 
                    style={{ 
                        position: 'absolute', 
                        top: 0, 
                        bottom: 0, 
                        left: 0, 
                        right: 0 
                    }} 
                />
            </div>
        </div>
    );
};

export default DesignMapFramed;